import './subGrowerStyle.css';
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';

import { ADD_GROWER, GET_ADDRESS_BY_PINCODE, authKey, GET_ALL_BLOCKLIST_AND_REVENUECIRCLE } from '../../../../common/URLs';
import { ADDRESS_ERROR, APPLICANT_ERROR, BLOCK_LIST, EMPTY_FIELD_ERROR, FIELD_CANNOT_BE_ZERO_ERROR, FOREST, GENDER, INDIVIDUAL, JFMC, LAND_AREA_UNIT, MOBILE_NO_ERROR, NUMBER_OF_CLUMPS_LIMIT_ERROR, OTHER_GOV_AGENCY, PINCODE_NO_ERROR, PLOT_AREA_KATHA_ERROR, PLOT_AREA_REST_ERROR, REVENUE_CIRCLE, SALUTATION, SEARCH_ICON_ERROR, VALID_NAME_OF_APPLICANT_ERROR, INVALID_OTP_ERROR, LINKS } from '../../../../common/constants';
import { loaderService } from '../../../../common/custom-loader/loader-service';
import { Container, Card, CardContent, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import { addressMaxLength, emailUrnPassMaxLength, emailValidation, maxNameLength, mobileNoMaxLength, totalClumpsMaxLength, mobileNumberValidation, nameValidation, otpMaxLength, pincodeValidation, plotValidationForKatha, plotValidationForOtherUnits, totalNumberOfClumpValidation, totalPlotsMaxLength, typeNumberValid, VALIDATION, pincodeMaxLength } from '../../../../common/commonValidations';
import resolveIcon from "../../../../images/resolved.png";
import { sendOTP, validateOTP } from '../../../../common/Utils';
import { CommonPincodeMUI } from '../../../../common/common-pincode/commonPincodeMUI';
import { Button } from '@mui/material';
import jwt from 'jwt-decode';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import { PROD } from '../../../../common/constants';
import BackButton from '../../../../common/backButton';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from '../../../../common/commonPopovers/confirmationPopover';
import { PreRegPopover } from '../../../../common/commonPopovers/preRegPopver';
import { handleNumberFieldFocus } from '../../../../common/commonFunction';
import { CloseIcon, SubmitIcon } from '../../../../common/icons';
import BadgeComponent from '../../../../common/badge';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../../../../AppInsights';
import apiClient from '../../../../axios';

const GrowerSubCategory = () => {
    const { t, i18n } = useTranslation();
    const { state } = useLocation();
    const { category, subCategory } = state;
    const [mobileOTPValidated, setMobileOTPValidated] = useState(false);
    const [checkTermChecked, setCheckTermChecked] = useState(false);
    const [checkTermDisable, setCheckTermDisable] = useState(false);
    const [otpHidden, setOtpHidden] = useState(true);
    const [growerDetails, setGrowerDetails] = useState();
    const [bambooPincodeDetails, setBambooPincodeDetails] = useState();
    const [verifyMobileNo, setVerifyMobileNo] = useState(false);
    const [isAddressSame, setIsAddressSame] = useState(false);

    const [logModalOpenConfirm, setLogModalOpenConfirm] = useState(false);
    const handleLogModalConfirmOpen = () => setLogModalOpenConfirm(true);
    const handleLogModalConfirmClose = () => setLogModalOpenConfirm(false);

    const [logModalOpenSuccess, setLogModalOpenSuccess] = useState(false);
    const handleLogModalSuccessOpen = () => setLogModalOpenSuccess(true);
    const handleLogModalSuccessClose = () => setLogModalOpenSuccess(false);

    const decoded = getLocalStorageItem('id_token') ? (getLocalStorageItem('id_token') == "PreReg") ? null : jwt(getLocalStorageItem('id_token')) : null;
    const initialData = {
        fullName: '',
        contactPersonFirstname: '',
        contactPersonMiddlename: '',
        contactPersonLastname: '',
        Gender: GENDER[0],
        contactPersonSalutation: SALUTATION[0],
        mobileNo: '',
        emailId: '',
        address: '',
        state: '',
        district: '',
        blockName: '',
        revenueCircle: '',
        pincode: '',
        landName: '',
        landArea: '',
        landAreaUnit: LAND_AREA_UNIT[0],
        totalNoOfBambooClumps: '',
        isvalid: false,
        totalNumberOfClumps: '',
        totalNumberOfPlots: '',
        bambooPincode: '',
        bambooAddress: '',
        bambooBlockName: '',
        bambooState: '',
        bambooDistrict: '',
        bambooRevenueCircle: ''
    };
    const [details, setDetails] = useState(initialData);
    const intitialError = {
        fullnameError: '',
        firstNameError: '',
        MobileNumerError: '',
        emailIdError: '',
        addressError: '',
        pincodeError: '',
        landareaError: '',
        clumpsError: '',
        searchError: '',
        GenderError: '',
        landNameError: '',
        bambooPincodeError: '',
        bambooSearchError: '',
        totalNumberOfClumpsError: '',
        totalNumberOfPlotsError: '',
        middleNameError: '',
        lastNameError: '',
        plotAddressError: '',
        acceptTermError: ''
    };
    const [errorMessage, setErrorMessage] = useState(intitialError);
    const [pincodeAddressDetails, setPincodeAddressDetails] = useState();
    const [otpValue, setOtpValue] = useState();

    useEffect(() => {

        if (growerDetails) {
            if (growerDetails.isSuccess) {
                handleLogModalSuccessOpen();
            }
            else {
                if (growerDetails.message) {
                    toast.error(growerDetails.message);
                } else
                    toast.error("Grower creation failed");
            }
        }

    }, [growerDetails]);
    const onClickVerifyMobileNo = (e) => {
        e.preventDefault();
        setErrorMessage({ ...errorMessage, OTPError: "" });
        setOtpValue("");
        if (isValidMobileNumber(details.mobileNo)) {
            sendOTP(details.mobileNo, callBackMobileValidation);
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
        }
        else
            setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
    }
    const clear = (e) => {
        setDetails(initialData);
        setMobileOTPValidated(false);
        setCheckTermChecked(false);
        setCheckTermDisable(false);
        setOtpHidden(true);
        setGrowerDetails();
        setBambooPincodeDetails();
        setVerifyMobileNo(false);
        setIsAddressSame(false);
        setErrorMessage(intitialError);
    }
    const callBackMobileValidation = (response) => {
        setErrorMessage({ ...errorMessage, mobileNoError: "" });
        if (response.isSuccess) {
            setErrorMessage({ ...errorMessage, OTPSentError: "", mobileNoError: "", acceptTermError: "", acceptTermError: "" })
            setVerifyMobileNo(true);
            setOtpHidden(false);
            setCheckTermChecked(true);
            setCheckTermDisable(true);
        }

    }
    const handleCheckboxTerms = (e) => {
        if (e.target.checked) {
            e.preventDefault();
            setErrorMessage({ ...errorMessage, OTPError: "" });
            setOtpValue("");
            if (isValidMobileNumber(details.mobileNo)) {
                sendOTP(details.mobileNo, callBackMobileValidation);
                setErrorMessage({ ...errorMessage, mobileNoError: "", acceptTermError: "" });
                setCheckTermChecked(true);
                setCheckTermDisable(true);
            }
            else {
                setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
                setCheckTermChecked(false);
            }
        }
    }
    const handleChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setDetails({ ...details, blockName: e.target.value });
        }
        if (type == REVENUE_CIRCLE) {
            setDetails({ ...details, revenueCircle: e.target.value, });
        }
    }
    const handleBambooChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setDetails({ ...details, bambooBlockName: e.target.value });
        }
        if (type == REVENUE_CIRCLE) {
            setDetails({ ...details, bambooRevenueCircle: e.target.value, });
        }

    }
    const onOtpChange = (e) => {
        const limit = 6;
        setOtpValue(e.target.value.slice(0, limit))
        if (e.target.value.length == 6) {
            validateOTP(details.mobileNo, e.target.value, callBackOTPValidation);
        }
    }
    const callBackOTPValidation = (response) => {
        setErrorMessage({ ...errorMessage, OTPSentError: "" });
        setErrorMessage({ ...errorMessage, mobileNoError: "" });
        if (response.isSuccess === true) {
            setVerifyMobileNo(false);
            setOtpHidden(true);
            setMobileOTPValidated(true);
            setErrorMessage({ ...errorMessage, OTPError: "" });
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
        }
        else {
            setErrorMessage({ ...errorMessage, mobileNoError: INVALID_OTP_ERROR });
        }
    }
    const isValidMobileNumber = (mobileNo) => {
        if (mobileNo.length == 10) {
            return true;
        }
        return false;
    }
    const navigate = useNavigate();


    const handleChange = (e) => {
        setDetails({
            ...details, [e.target.name]: [e.target.value]
        });
        if (e.target.name === "totalNumberOfPlots") {
            setDetails({ ...details, [e.target.name]: plotValidationForOtherUnits(e.target.value) })
            if ((details.totalNumberOfPlots).length < 6) {
                setErrorMessage({ ...errorMessage, totalNumberOfPlotsError: "" });
                if (e.target.value > 0) {
                    setErrorMessage({ ...errorMessage, totalNumberOfPlotsError: "" });
                } else setErrorMessage({ ...errorMessage, totalNumberOfPlotsError: FIELD_CANNOT_BE_ZERO_ERROR });
            } else setErrorMessage({ ...errorMessage, totalNumberOfPlotsError: PLOT_AREA_REST_ERROR });
        }
        else if (e.target.name === "address") {
            const limit = addressMaxLength;
            if ((e.target.value).length > 0) {
                var address = VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, limit));
                setDetails({ ...details, [e.target.name]: address })
                setErrorMessage({ ...errorMessage, addressError: "" })
            } else setErrorMessage({ ...errorMessage, addressError: ADDRESS_ERROR })
        }
        else if (e.target.name === "fullName") {
            // Allow only alphabets, numbers and spaces — strip everything else
            const cleanedValue = e.target.value.replace(/[^a-zA-Z0-9&/ ]/g, "");
            setDetails({
                ...details,
                [e.target.name]: cleanedValue
            });
            if (VALIDATION.fullNameValidation(cleanedValue)) {
                setErrorMessage({
                    ...errorMessage,
                    fullnameError: ""
                });
            } else {
                setErrorMessage({
                    ...errorMessage,
                    fullnameError: "Only letters and numbers allowed"
                });
            }
        }

        else if (e.target.name === "mobileNo") {
            const limit = 10;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length < 10) {
                setErrorMessage({ ...errorMessage, mobileNoError: "Please enter 10 digit mobile number" });
            }
            else setErrorMessage({ ...errorMessage, mobileNoError: "" });

        }
        else if (e.target.name === "pincode") {
            const limit = pincodeMaxLength;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length < limit) {
                setErrorMessage({ ...errorMessage, pincodeError: "Please enter 6 digit pincode" });
            }
            else setErrorMessage({ ...errorMessage, pincodeError: "" });
        }

        else if (e.target.name === "bambooPincode") {
            const limit = pincodeMaxLength;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length < limit) {
                setErrorMessage({ ...errorMessage, bambooPincodeError: PINCODE_NO_ERROR });
            }
            else setErrorMessage({ ...errorMessage, bambooPincodeError: "" });
        }
        else if (e.target.name === "totalNumberOfClumps") {
            setDetails({ ...details, [e.target.name]: totalNumberOfClumpValidation(e.target.value) })
            // if ((details.totalNumberOfClumps).length < 6) {
            //     setErrorMessage({ ...errorMessage, totalNumberOfClumpsError: "" });
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, totalNumberOfClumpsError: "" });
            } else setErrorMessage({ ...errorMessage, totalNumberOfClumpsError: "Please enter total number of clumps" });
            // } else setErrorMessage({ ...errorMessage, totalNumberOfClumpsError: NUMBER_OF_CLUMPS_LIMIT_ERROR });
        }
        else if (e.target.name === "plotAddress") {
            var limit = addressMaxLength;
            if ((e.target.value).length > 0) {
                var address = VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, limit));
                setDetails({ ...details, [e.target.name]: address })
                setErrorMessage({ ...errorMessage, plotAddressError: "" })
            } else setErrorMessage({ ...errorMessage, plotAddressError: ADDRESS_ERROR })
        }
        else if (e.target.name === "Gender") {
            setDetails({ ...details, [e.target.name]: e.target.value })
            setErrorMessage({ ...errorMessage, GenderError: "" })
        }
        else if (e.target.name === "contactPersonFirstname") {
            const Middlename_regex = /^[a-zA-Z]*$/;
            setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            if ((e.target.value).length > 0) {
                if (!((e.target.value).match(Middlename_regex))) {
                    setErrorMessage({ ...errorMessage, firstNameError: VALID_NAME_OF_APPLICANT_ERROR })
                }
                else
                    setErrorMessage({ ...errorMessage, firstNameError: "" })
            } else {
                setErrorMessage({ ...errorMessage, firstNameError: "Please enter First Name" })

            }
        }
        else if (e.target.name === "contactPersonMiddlename") {
            setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            } else return
        }
        else if (e.target.name === "contactPersonLastname") {
            setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            } else return
        }

        else if (e.target.name === 'emailId') {
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, 50) })
            if ((e.target.value).length > 0) {
                if (emailValidation(e.target.value.slice(0, 50))) {
                    setErrorMessage({ ...errorMessage, emailIdError: "" })
                } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid Email Address" })
            }
            else setErrorMessage({ ...errorMessage, emailIdError: "" })
        }
        else
            setDetails({ ...details, [e.target.name]: e.target.value })
    };

    const getUpdatedPersonalAddressData = (data) => {
        setDetails({
            ...details,
            pincode: data.pincode,
            state: data.pincodeState,
            district: data.pincodeDistrict,
            subDivision: data.pincodeSubDivision,
            revenueCircle: data.selectedRevenueCircle,
            blockName: data.selectedBlockName,

        })
        // if (data.pincodeState && data.pincodeDistrict && (data.selectedRevenueCircle || data.selectedBlockName)) {
        if (data.pincodeState && data.pincodeDistrict ) {
            setErrorMessage({ ...errorMessage, pincodeError: "", searchError: "" });
        } else {
            setErrorMessage({ ...errorMessage, pincodeError: "Please enter a valid pincode", searchError: "" });
        }
    }
    const getUpdatedBambooAddressData = (data) => {
        setDetails({
            ...details,
            bambooPincode: data.pincode,
            bambooState: data.pincodeState,
            bambooDistrict: data.pincodeDistrict,
            bambooSubDivision: data.pincodeSubDivision,
            bambooRevenueCircle: data.selectedRevenueCircle,
            bambooBlockName: data.selectedBlockName,


        })
        if (data.pincodeState && data.pincodeDistrict && (data.selectedRevenueCircle || data.selectedBlockName)) {
            setErrorMessage({ ...errorMessage, bambooSearchError: "", bambooPincodeError: "" });
        }
        else {
            setErrorMessage({ ...errorMessage, bambooPincodeError: "Please enter a valid pincode", bambooSearchError: "" });
        }
    }
    const validateDetails = () => {
        if ((!details.fullName && subCategory !== t('preReg.individual'))) {
            setErrorMessage({ ...errorMessage, fullnameError: APPLICANT_ERROR });
            return false;
        }
        else if (!details.address || !VALIDATION.noSpecialCharacterValidation(details.address)) {
            setErrorMessage({ ...errorMessage, addressError: "Please enter Permanent Address" });
            return false;
        }
        else if ((details.pincode).length < 6) {
            setErrorMessage({ ...errorMessage, pincodeError: PINCODE_NO_ERROR });
            return false;
        }
        else if (!details.state) {
            setErrorMessage({ ...errorMessage, pincodeError: "Please enter a valid pincode" });
            return false;
        }
        // else if (!details.blockName && !details.revenueCircle) {
        //     setErrorMessage({ ...errorMessage, pincodeError: "Please select Block Name or Revenue Circle" });
        //     return false;
        // }
        else if (!details.contactPersonFirstname) {
            setErrorMessage({ ...errorMessage, firstNameError: "Please enter First Name" });
            return false;
        }
        else if (!details.mobileNo) {
            setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
            return false;
        }
        //else if (mobileOTPValidated === false) {
        //    setErrorMessage({ ...errorMessage, mobileNoError: "Please Verify Mobile No." });
        //    return false;
        //}

        else if (!details.totalNumberOfPlots) {
            setErrorMessage({ ...errorMessage, totalNumberOfPlotsError: "Please enter Total Plot Area" });
            return false;
        }
        else if (!details.totalNumberOfClumps) {
            setErrorMessage({ ...errorMessage, totalNumberOfClumpsError: "Please enter Total number of Clumps" });
            return false;
        }
        else if (!details.plotAddress || !VALIDATION.noSpecialCharacterValidation(details.plotAddress)) {
            setErrorMessage({ ...errorMessage, plotAddressError: "Please enter Plot Address" });
            return false;
        }
        else if ((details.bambooPincode).length < 6) {
            setErrorMessage({ ...errorMessage, bambooPincodeError: PINCODE_NO_ERROR });
            return false;
        }
        else if (!details.bambooState) {
            setErrorMessage({ ...errorMessage, bambooPincodeError: "Please enter a valid pincode" });
            return false;
        }
        // else if (!details.bambooBlockName && !details.bambooRevenueCircle) {
        //     setErrorMessage({ ...errorMessage, bambooPincodeError: "Please select Block Name or Revenue Circle" });
        //     return false;
        // }
        else if (!checkTermChecked) {
            setErrorMessage({ ...errorMessage, acceptTermError: "Please accept the Privacy Policy and Terms of Use of ABEPL." });
            return false;
        }
        else if (!mobileOTPValidated && verifyMobileNo) {
            setErrorMessage({ ...errorMessage, acceptTermError: "Please enter the OTP sent to your mobile number" });
            return false;
        }
        else
            return true;
    }
    const onSubmit = () => {
        handleLogModalConfirmClose();
        getGrowerDetails();

    };

    const handleCheckboxAddress = (e) => {
        setIsAddressSame(!isAddressSame)
        if (!isAddressSame) {
            if (details.address) {
                setDetails({
                    ...details,
                    plotAddress: details.address,
                    bambooPincode: details.pincode,
                    bambooState: details.state,
                    bambooDistrict: details.district,
                    bambooRevenueCircle: details.revenueCircle,
                    bambooBlockName: details.blockName,
                })

            } else setErrorMessage({ ...errorMessage, addressError: ADDRESS_ERROR });
        } else {
            setDetails({ ...details, plotAddress: '', bambooPincode: '', bambooRevenueCircle: '', bambooState: '', bambooDistrict: '', bambooBlockName: '' })
        }
    }
    const confirmSubmission = (e) => {
        e.preventDefault();
        if (validateDetails()) {
            handleLogModalConfirmOpen();
        }
    }
    const getGrowerDetails = () => {
        if (subCategory === FOREST) {
            const data = {
                "name": details.fullName,
                "contactPersonFirstname": details.contactPersonFirstname,
                "contactPersonMiddlename": details.contactPersonMiddlename,
                "contactPersonLastname": details.contactPersonLastname,
                "contactPersonGender": details.Gender,
                "contactPersonSalutation": details.contactPersonSalutation,
                "mobileNo": details.mobileNo,
                "growerCategory": 'Grower',
                "growerType": subCategory,
                "address": details.address,
                "pincode": details.pincode,
                "state": details.state,
                "district": details.district,
                "revenueCircle": details.revenueCircle,
                "blockName": details.blockName,
                "forestDeptAddress": details.plotAddress,
                "forestDeptPincode": details.bambooPincode,
                "forestDeptState": details.bambooState,
                "forestDeptDistrict": details.bambooDistrict,
                "forestDeptSubDivision": details.bambooSubDivision,
                "forestDeptRevenueCircle": details.bambooRevenueCircle,
                "forestDeptBlockName": details.bambooBlockName,
                "forestDeptPostOffice": "",
                "forestDeptTotalLandArea": details.totalNumberOfPlots + ' ' + details.landAreaUnit,
                "forestDeptTotalNoOfBambooClumps": details.totalNumberOfClumps,
                "otp": otpValue,
                "isOtpValidated": true,
                "acceptedTerms": checkTermChecked,
                "emailId": details.emailId,
            }
            addGrowerApiCall(data)
        } else if (subCategory === t('preReg.individual')) {
            const data = {
                "name": details.contactPersonFirstname,
                "contactPersonFirstname": details.contactPersonFirstname,
                "contactPersonMiddlename": details.contactPersonMiddlename,
                "contactPersonLastname": details.contactPersonLastname,
                "contactPersonGender": details.Gender,
                "contactPersonSalutation": details.contactPersonSalutation,
                "mobileNo": details.mobileNo,
                "growerCategory": 'Grower',
                "growerType": subCategory,
                "address": details.address,
                "pincode": details.pincode,
                "state": details?.state,
                "district": details?.district,
                "revenueCircle": details?.revenueCircle,
                "blockName": details?.blockName,
                "plotAddress": details.plotAddress,
                "plotPincode": details.bambooPincode,
                "plotState": details.bambooState,
                "plotDistrict": details.bambooDistrict,
                "plotRevenueCircle": details.bambooRevenueCircle,
                "plotBlockName": details.bambooBlockName,
                "plotPostOffice": "string",
                "plotTotalLandArea": details.totalNumberOfPlots + ' ' + details.landAreaUnit,
                "plotTotalNoOfBambooClumps": details.totalNumberOfClumps,
                "otp": otpValue,
                "isOtpValidated": true,
                "acceptedTerms": checkTermChecked,
                "emailId": details.emailId,
            }
            addGrowerApiCall(data)
        } else {
            const data = {
                "name": details.fullName,
                "contactPersonFirstname": details.contactPersonFirstname,
                "contactPersonMiddlename": details.contactPersonMiddlename,
                "contactPersonLastname": details.contactPersonLastname,
                "contactPersonGender": details.Gender,
                "contactPersonSalutation": details.contactPersonSalutation,
                "mobileNo": details.mobileNo,
                "growerCategory": 'Grower',
                "growerType": subCategory,
                "address": details.address,
                "pincode": details.pincode,
                "state": details?.state,
                "district": details?.district,
                "revenueCircle": details?.revenueCircle,
                "blockName": details?.blockName,
                "plotAddress": details.plotAddress,
                "plotPincode": details.bambooPincode,
                "plotState": details.bambooState,
                "plotDistrict": details.bambooDistrict,
                "plotRevenueCircle": details.bambooRevenueCircle,
                "plotBlockName": details.bambooBlockName,
                "plotPostOffice": "string",
                "plotTotalLandArea": details.totalNumberOfPlots + ' ' + details.landAreaUnit,
                "plotTotalNoOfBambooClumps": details.totalNumberOfClumps,
                "otp": otpValue,
                "isOtpValidated": true,
                "acceptedTerms": checkTermChecked,
                "emailId": details.emailId,
            }
            addGrowerApiCall(data)

        }

    }
    const addGrowerApiCall = (dataForApi) => {
        loaderService.showLoader();
        let headers = {
            AuthKey: authKey,
        }
        if (getLocalStorageItem('id_token')) {
            headers = {
                AuthKey: authKey,
                Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
            }
        }
        apiClient.post(ADD_GROWER,
            dataForApi,
            {
                headers: headers,
            }
        )
            .then((response) => {
                if (response.data.isSuccess === false || response.data.message.indexOf("mobile number") >= 0) {
                    setVerifyMobileNo(false);
                    setMobileOTPValidated(false);
                    setCheckTermChecked(false);
                    setCheckTermDisable(false);
                    setErrorMessage({ ...errorMessage, mobileNoError: "Please add different number!" });
                }
                setGrowerDetails(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });

    }

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>REG02</p>}
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <BackButton navigate={navigate} />
                    <Typography variant="h5" gutterBottom>
                        {i18n.resolvedLanguage === 'as' ? (subCategory + " " + t('preReg.grower') + t('preReg.r') + " " + t('preReg.pre-registration')) : (subCategory + " " + "Pre-Registration")}
                        {/* Grower {subCategory} Pre-Registration */}
                    </Typography>
                </Stack>
                <Card>
                    <CardContent>
                        <Grid container spacing={2} direction="row">
                            <Grid item xs={12} >
                                <Grid container >
                                    <Grid item xs={6}>

                                        {subCategory !== t('preReg.individual') && subCategory !== OTHER_GOV_AGENCY && subCategory !== t('preReg.forest') &&
                                            <><TextField
                                                required
                                                sx={{ width: "53ch" }}
                                                error={errorMessage?.fullnameError}
                                                helperText={errorMessage?.fullnameError}
                                                label={i18n.resolvedLanguage === 'as' ? subCategory + " " + t('preReg.name') : t('preReg.name') + " of " + subCategory}
                                                inputProps={{
                                                    maxLength: maxNameLength
                                                }}
                                                type="text"
                                                name="fullName"
                                                value={details.fullName}
                                                onChange={(e) => handleChange(e)} />  </>}
                                        {subCategory === OTHER_GOV_AGENCY &&
                                            <> <TextField
                                                required
                                                sx={{ width: "53ch" }}
                                                error={errorMessage?.fullnameError}
                                                helperText={errorMessage?.fullnameError}
                                                label="Name of Office"
                                                inputProps={{
                                                    maxLength: maxNameLength
                                                }}
                                                type="text"
                                                name="fullName"
                                                value={details.fullName}
                                                onChange={(e) => handleChange(e)} />
                                            </>}
                                        {subCategory === FOREST &&
                                            <> <TextField
                                                sx={{ width: "53ch" }}
                                                required
                                                error={errorMessage?.fullnameError}
                                                helperText={errorMessage?.fullnameError}
                                                label="Name of Forest Division Office"
                                                inputProps={{
                                                    maxLength: maxNameLength,
                                                    pattern: "[A-Aa-z0-9&/]*",
                                                }}
                                                type="text"
                                                name="fullName"
                                                value={details.fullName}
                                                onChange={(e) => handleChange(e)} />
                                                <BadgeComponent currentLength={details?.fullName?.length} maxLength={maxNameLength} />
                                            </>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    {
                                        subCategory !== t('preReg.individual') ?
                                            <>
                                                {subCategory !== t('preReg.individual') &&
                                                    <Grid item xs={12} mt={1}>
                                                        <Box sx={{ fontWeight: 'bold', fontSize: 16 }}>
                                                            {t('preReg.registeredAddress')}
                                                        </Box>
                                                    </Grid>}
                                                <Grid item xs={12}>
                                                    <TextField fullWidth
                                                        error={errorMessage?.addressError}
                                                        helperText={errorMessage?.addressError}
                                                        required
                                                        label={subCategory === t('preReg.individual') ? t('preReg.permanentAddress') : t('main.officeAddressTitle')}
                                                        type="text"
                                                        multiline
                                                        name="address"
                                                        value={details.address}
                                                        onChange={(e) => handleChange(e)}

                                                    />
                                                    <BadgeComponent currentLength={details?.address?.length} maxLength={addressMaxLength} />

                                                </Grid>
                                                <CommonPincodeMUI setErrorMessage={setErrorMessage}
                                                    pincode={details?.pincode}
                                                    state={details?.state}
                                                    district={details?.district}
                                                    revenueCircle={details?.revenueCircle}
                                                    blockName={details?.blockName}
                                                    onHandleCallback={getUpdatedPersonalAddressData}
                                                    pincodeError={errorMessage.pincodeError}
                                                    searchError={errorMessage.searchError}
                                                    handleChangeSelect={handleChangeSelect}
                                                />
                                            </>
                                            : null
                                    }
                                    <Grid item xs={12}>
                                        <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                            {subCategory !== t('preReg.individual') ? t('preReg.contactDetails') : t('preReg.personalDetails')}
                                        </Typography>
                                        {subCategory !== t('preReg.individual') &&
                                            <Box sx={{ fontWeight: 'bold', fontSize: 16 }}>
                                                {t('preReg.contactPerson')}
                                            </Box>}
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl fullWidth>
                                            <InputLabel>{t('preReg.salutation')}</InputLabel>
                                            <Select
                                                label={t('preReg.salutation')}
                                                name="contactPersonSalutation"
                                                value={details.contactPersonSalutation}
                                                onChange={(e) => handleChange(e)}
                                                inputProps={{
                                                    style: { textTransform: "uppercase" }
                                                }}                                            >
                                                {
                                                    SALUTATION?.map((item) =>
                                                        <MenuItem value={item}>{item}</MenuItem>)
                                                }
                                            </Select>
                                            {/* <FormHelperText sx={{ color: 'red' }}>{errorMessage?.categoryError}</FormHelperText> */}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage?.firstNameError}
                                            helperText={errorMessage?.firstNameError}
                                            label={t('preReg.firstname')}
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            type="text"
                                            name="contactPersonFirstname"
                                            value={details.contactPersonFirstname}
                                            onChange={(e) => handleChange(e)} />
                                        <BadgeComponent currentLength={details?.contactPersonFirstname?.length} maxLength={maxNameLength} />

                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            error={errorMessage?.middleNameError}
                                            helperText={errorMessage?.middleNameError}
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            type="text"
                                            label={t('preReg.middlename')}
                                            name="contactPersonMiddlename"
                                            value={details.contactPersonMiddlename}
                                            onChange={(e) => handleChange(e)} />
                                        <BadgeComponent currentLength={details?.contactPersonMiddlename?.length} maxLength={maxNameLength} />

                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            error={errorMessage?.lastNameError}
                                            helperText={errorMessage?.lastNameError}
                                            label={t('preReg.lastname')}
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            type="text"
                                            name="contactPersonLastname"
                                            value={details.contactPersonLastname}
                                            onChange={(e) => handleChange(e)} autoComplete="off" />
                                        <BadgeComponent currentLength={details?.contactPersonLastname?.length} maxLength={maxNameLength} />

                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl fullWidth>
                                            <InputLabel>{t('preReg.gender')}</InputLabel>
                                            <Select
                                                label={t('preReg.gender')}
                                                name="Gender" value={details.Gender} onChange={(e) => handleChange(e)}>
                                                {
                                                    GENDER?.map((item) =>
                                                        <MenuItem key={item} value={item}>{item}</MenuItem>)
                                                }
                                            </Select>
                                            {/* <FormHelperText sx={{ color: 'red' }}>{errorMessage?.categoryError}</FormHelperText> */}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.mobileNoError}
                                            helperText={errorMessage.mobileNoError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('preReg.mobileNo')}
                                            name="mobileNo"
                                            maxLength="10"
                                            onKeyDown={(evt) => typeNumberValid(evt)}
                                            value={details.mobileNo}
                                            onChange={(e) => handleChange(e)}
                                            disabled={mobileOTPValidated} />
                                        <BadgeComponent currentLength={details?.mobileNo?.length} maxLength={mobileNoMaxLength} />

                                        {mobileOTPValidated === true && <div className="commonVerifyText" hidden={!mobileOTPValidated}><a href="#">Verified</a>
                                            <img className="commonOtpImg" src={resolveIcon} alt="" /></div>}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            error={errorMessage.emailIdError}
                                            helperText={errorMessage.emailIdError}
                                            fullWidth
                                            label="E-mail"
                                            name='emailId'
                                            value={details.emailId}
                                            onChange={(e) => handleChange(e)} />
                                        <BadgeComponent currentLength={details?.emailId?.length} maxLength={emailUrnPassMaxLength} />

                                    </Grid>
                                    {
                                        subCategory === t('preReg.individual') ?
                                            <>
                                                {subCategory !== t('preReg.individual') &&
                                                    <Grid item xs={12} mt={1}>
                                                        <Box sx={{ fontWeight: 'bold', fontSize: 16 }}>
                                                            {t('preReg.registeredAddress')}
                                                        </Box>
                                                    </Grid>}
                                                <Grid item xs={12}>
                                                    <TextField fullWidth
                                                        error={errorMessage?.addressError}
                                                        helperText={errorMessage?.addressError}
                                                        required
                                                        label={subCategory === t('preReg.individual') ? t('preReg.permanentAddress') : t('main.officeAddressTitle')}
                                                        type="text"
                                                        multiline
                                                        name="address"
                                                        value={details.address}
                                                        onChange={(e) => handleChange(e)}
                                                    />
                                                    <BadgeComponent currentLength={details?.address?.length} maxLength={addressMaxLength} />

                                                </Grid>
                                                <CommonPincodeMUI setErrorMessage={setErrorMessage}
                                                    pincode={details?.pincode}
                                                    state={details?.state}
                                                    district={details?.district}
                                                    revenueCircle={details?.revenueCircle}
                                                    blockName={details?.blockName}
                                                    onHandleCallback={getUpdatedPersonalAddressData}
                                                    pincodeError={errorMessage.pincodeError}
                                                    searchError={errorMessage.searchError}
                                                    handleChangeSelect={handleChangeSelect}
                                                />
                                            </> : null}
                                </Grid>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                    {t('preReg.bambooDetails')}
                                </Typography>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.totalNumberOfPlotsError}
                                            helperText={errorMessage.totalNumberOfPlotsError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('preReg.totalPlotArea')}
                                            min="0"
                                            name="totalNumberOfPlots"
                                            value={details.totalNumberOfPlots}
                                            onKeyDown={(evt) => typeNumberValid(evt)}
                                            onChange={(e) => handleChange(e)}
                                            InputProps={{
                                                endAdornment: (
                                                    <Select
                                                        variant="standard"
                                                        size="small"
                                                        value={details.landAreaUnit}
                                                        name="landAreaUnit"
                                                        onChange={(e) => handleChange(e)}
                                                    >
                                                        {LAND_AREA_UNIT.map((option) => (
                                                            <MenuItem key={option} value={option}>
                                                                {option}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                ),
                                            }}
                                        />
                                        <BadgeComponent currentLength={details?.totalNumberOfPlots?.length} maxLength={totalPlotsMaxLength} />

                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.totalNumberOfClumpsError}
                                            helperText={errorMessage.totalNumberOfClumpsError}
                                            value={details.totalNumberOfClumps}
                                            name="totalNumberOfClumps"
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('preReg.totalClumps')}
                                            onKeyDown={(evt) => typeNumberValid(evt)}
                                            onChange={(e) => handleChange(e)} />
                                        <BadgeComponent currentLength={details?.totalNumberOfClumps?.length} maxLength={totalClumpsMaxLength} />

                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormGroup>
                                            <FormControlLabel control={<Checkbox checked={isAddressSame} onChange={() => handleCheckboxAddress()} />} label={subCategory === t('preReg.individual') ? t('preReg.sameasPermanentAdd') : t('preReg.sameasRegisteredAdd')} />
                                        </FormGroup>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            error={errorMessage?.plotAddressError}
                                            helperText={errorMessage?.plotAddressError}
                                            required
                                            label={t('preReg.plotAddress')}
                                            type="text"
                                            multiline
                                            name="plotAddress"
                                            value={details.plotAddress || ''}
                                            onChange={(e) => handleChange(e)}

                                        />
                                        <BadgeComponent currentLength={details?.plotAddress?.length} maxLength={addressMaxLength} />

                                    </Grid>
                                    <CommonPincodeMUI setErrorMessage={setErrorMessage}
                                        pincode={details?.bambooPincode}
                                        state={details?.bambooState}
                                        district={details?.bambooDistrict}
                                        revenueCircle={details?.bambooRevenueCircle}
                                        blockName={details?.bambooBlockName}
                                        onHandleCallback={getUpdatedBambooAddressData}
                                        pincodeError={errorMessage.bambooPincodeError}
                                        searchError={errorMessage.bambooSearchError}
                                        handleChangeSelect={handleBambooChangeSelect}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox checked={checkTermChecked} onChange={(e) => handleCheckboxTerms(e)} disabled={checkTermDisable} />} label={<><label for="chkTerms"> I agree to the <a href={LINKS.PRIVACY_POLICY}>Privacy Policy</a> and <a href={LINKS.TERMS_OF_USE}>Terms of Use</a> of ABEPL.</label></>} ></FormControlLabel>
                        </FormGroup>
                        <div style={{ color: "#d32f2f", fontSize: "0.75 rem" }}>{errorMessage.acceptTermError}</div>
                    </Grid>
                    <Grid item xs={3}>
                        {verifyMobileNo &&
                            <>
                                <TextField fullWidth
                                    type="number"
                                    onFocus={handleNumberFieldFocus}
                                    onKeyDown={(evt) => typeNumberValid(evt)}
                                    onChange={(e) => onOtpChange(e)}
                                    label={t('preReg.otp')}
                                    value={otpValue} />
                                <BadgeComponent currentLength={otpValue?.length} maxLength={otpMaxLength} />
                            </>
                        }
                        {verifyMobileNo === true &&
                            <div>
                                <a href='#' className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend OTP</a></div>
                        }

                    </Grid>
                </Grid>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button sx={{ minWidth: 100, marginRight: 1 }} variant="outlined" onClick={(e) => clear(e)} startIcon={<CloseIcon />}>{t('preReg.clear')}</Button>
                    <Button sx={{ minWidth: 100 }} disabled={!mobileOTPValidated} variant="contained" onClick={(e) => confirmSubmission(e)} endIcon={<SubmitIcon />}>{t('preReg.submit')}</Button>
                </Box>
            </Container>
            <ConfirmationPopover action="Submit" onOpen={logModalOpenConfirm} onConfirm={onSubmit} onClose={handleLogModalConfirmClose} />
            <PreRegPopover onOpen={logModalOpenSuccess} onClose={handleLogModalSuccessClose} urn={growerDetails?.grower?.regStakeholderMaster?.urn} message="Grower created successfully" navigate={navigate} navigatePath={decoded != null && decoded && decoded.emails && decoded.emails[0] ? '/registrationHome/dashboard' : '/'} />
        </>
    );
}

export default withAITracking(reactPlugin, GrowerSubCategory);
